// extracted by mini-css-extract-plugin
export default {"VersionList":"VersionList_VersionList__zv3Uf","SegmentedContent":"VersionList_SegmentedContent__1731W","new":"VersionList_new__UCzpS"};